import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { Button, Card, CardActions, CardContent, Chip, LinearProgress, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DeleteAddress, GetAddresses, GetAddressLine2 } from '../../services/Address';
import { GetToken, GuestLogin, Me, RefreshSession, SetToken, SetUser } from '../../services/Session';
import theme from '../../styles/theme';
import { useStyles } from './styles';

export const AddressList = () => {
  const classes = useStyles();
  const history = useHistory();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [addressList, setAddressList] = useState([]);

  const getNextPath = () => {
    const nextPaths = {
      ticket: '/pesan-tiket',
      certificate: '/pesan-sertifikat',
      pre_order_member: '/pesan-pre-order-member',
      pre_order_internal: '/pesan-pre-order-internal',
    };

    return nextPaths[state.product_type] ?? '/pesan-produk';
  };

  const handleBackClick = () => {
    history.push(getNextPath(), state);
  };

  const handleAddClick = () => {
    history.push('/alamat/new', {
      ...state,
      totalAddress: addressList.length,
    });
  };

  const handleDeleteClick = async (e) => {
    const { id } = e.currentTarget.dataset;

    try {
      await DeleteAddress(id);
      await handleGetAddressList();
    } catch (err) {
      if (err.response?.status === 401) {
        if (GetToken().refresh_token !== null) {
          RefreshSession();
          alert('Gagal terhubung ke server, silahkan coba lagi!');
        } else {
          alert('Session timeout');
          handleLogout();
        }
      } else if (err.response?.data?.error?.message) {
        alert(err.response.data.error.message);
      } else {
        alert('Gagal terhubung ke server');
      }
    }
  };

  const handleEditClick = (e) => {
    const { id } = e.currentTarget.dataset;

    history.push(`/alamat/${id}`, state);
  };

  const handleLogout = useCallback(async () => {
    const loginResponse = await GuestLogin();
    const profileResponse = await Me(SetToken(loginResponse.data.token).access_token);

    SetUser(profileResponse.data);
    setTimeout(() => {
      history.push('/');
    }, 3000);
  }, [history]);

  const handleGetAddressList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await GetAddresses();

      if (res.data?.results?.length) {
        setAddressList(res.data.results);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        if (GetToken().refresh_token !== null) {
          RefreshSession();
          setTimeout(handleGetAddressList, 3000);
        } else {
          alert('gagal terhubung ke server');
          handleLogout();
        }
      } else if (err.response?.data?.error?.message) {
        alert(err.response.data.error.message);
      } else {
        alert('gagal terhubung ke server');
      }
    } finally {
      setLoading(false);
    }
  }, [handleLogout]);

  const handleSelectClick = (e) => {
    const { id } = e.currentTarget.dataset;
    const selectedAddress = addressList.find((address) => address.id === id);

    history.push(getNextPath(), { ...state, selectedAddress });
  };

  useEffect(() => {
    handleGetAddressList();
  }, [handleGetAddressList]);

  return (
    <ThemeProvider theme={theme}>
      <div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
      <header className="header">
        <Button
          onClick={handleBackClick}
          color="primary"
          style={{
            position: 'absolute',
            height: 60,
            width: 60,
            top: 0,
            left: 0,
            padding: 0,
          }}
        >
          <img alt="icon" src="/assets/svg/back.svg" />
        </Button>
        <div className="center">
          <h3 className="title">Daftar Alamat</h3>
        </div>
      </header>
      <section className={classes.container}>
        {loading && <LinearProgress />}
        <ul className={classes.list}>
          {addressList.map((address) => (
            <Card key={address.id} component="li" className={classes.card}>
              <CardContent data-id={address.id} onClick={handleSelectClick}>
                <Chip
                  component="h3"
                  className={classes.title}
                  color={address.is_primary ? 'primary' : 'default'}
                  label={address.contact_person}
                  size="small"
                />
                <Typography variant="body2" component="p">
                  {address.complete}
                  <br />
                  {GetAddressLine2(address)}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  data-id={address.id}
                  onClick={handleDeleteClick}
                  className={classes.button}
                  color="secondary"
                  size="small"
                  startIcon={<DeleteIcon />}
                >
                  Hapus
                </Button>
                <Button
                  data-id={address.id}
                  onClick={handleEditClick}
                  className={classes.button}
                  color="primary"
                  size="small"
                  startIcon={<EditIcon />}
                >
                  Ubah
                </Button>
              </CardActions>
            </Card>
          ))}
        </ul>
        <Button fullWidth variant="contained" color="primary" className={classes.add} onClick={handleAddClick}>
          Tambah Alamat
        </Button>
      </section>
      </div>
    </ThemeProvider>
  );
};
